'use client';

import { useEffect } from 'react';

/**
 * Clears the root layout's anti-flash veil (`<html style="visibility:
 * hidden">`) AFTER hydration commits.
 *
 * The veil is normally cleared by the synchronous boot script in <head> and
 * a 5s failsafe — both of which run BEFORE hydration on a slow load. React
 * 19's hydration then reconciles the <html> style attribute back to the
 * server value, and the re-applied `visibility: hidden` had no remaining
 * clearer: the entire app rendered invisible and unclickable until a manual
 * reload (found live: a saturated dev pod pushed hydration past the 5s
 * failsafe and every element hit-tested to <html>).
 *
 * An effect runs after the hydration commit, so this clear lands on the
 * value React just re-applied — the one ordering the head scripts can't
 * reach.
 */
export function UnveilOnHydration() {
  useEffect(() => {
    try {
      document.documentElement.style.visibility = '';
    } catch {
      /* nothing to unveil */
    }
  }, []);
  return null;
}
